import BelongsTo from './BelongsTo';
import HasMany from './HasMany';

export default {
	belongsTo: BelongsTo,
	hasMany: HasMany,
	hasAndBelongsToMany: HasMany,
};